import { render, staticRenderFns } from "./ShiftDetails.vue?vue&type=template&id=584b9494&scoped=true"
import script from "./ShiftDetails.vue?vue&type=script&lang=js"
export * from "./ShiftDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b9494",
  null
  
)

export default component.exports